module.exports = __webpack_public_path__ + "static/img/3-design-b1.5831b58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-design-b1.jpg
// module id = N9SH
// module chunks = 0